export const GET = "messages/GET";
export const UPDATE = "messages/UPDATE";
export const OPEN = "messages/OPEN";
